export enum PlanRewardType {
    UNLOCK_REQUISITES = 'unlock_requisites',
    PRIORITY_BOOST = 'priority_boost',
}
